import React, { Component } from 'react';
import { connect } from 'react-redux';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import PanelHeaderItem from "../components/PanelHeaderItem";
import FilterPanel from "../components/panels/FilterPanel";
import SubscriptionList from "./views/SubscriptionList";
import SubscriptionInfoPanel from "./panels/SubscriptionInfoPanel";
import LogPanel from "./panels/LogPanel";
import {getAllShopsWithAllOption} from "../lib/Shops";
import {withApollo} from "react-apollo";
import {List, fromJS} from "immutable";
import NotesPanel from "../notes/panels/NotesPanel";
import { requestCreateNote } from "../notes/NotesActions";
import {SUBSCRIPTION_TYPE} from "../notes/notes";
import PanelGroupController from '../components/PanelGroupController';
import ActionButton from '../components/ActionButton';

const statusFilterOptions = fromJS([
  {id: "active", label: "Active"},
  {id: "paused", label: "Paused"},
  {id: "cancelled", label: "Cancelled"}
])

class SubscriptionsPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handleSubscriptionIdClick = this.handleSubscriptionIdClick.bind(this);
    this.handlePanelItemSelection = this.handlePanelItemSelection.bind(this);
    this.state = {
      subscriptionId: "",
      hasSubscriptionSelection: false,
      selectedPanelId: "general",
      shopFilter: "",
      statusFilter: "active"
    }
  }

  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Subscriptions";

    return (
      <div className="SalesPage SubscriptionsPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem show={true} label="Filter" id="general" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={this.state.hasSubscriptionSelection} label="Properties" id="properties" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={this.state.hasSubscriptionSelection} label="Log" id="log" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={this.state.hasSubscriptionSelection} label="Notes" id="notes" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />            
          </div>
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton
              label="Annotate Subscription"
              show={this.state.hasSubscriptionSelection}
              onClick={this.handleAnnotateSubscription.bind(this)}
              />
          </PanelGroupController>
        </div>
      </div>
    );
  }

  renderView(page) {
    switch(page) {
      case "subscriptions":
        return (
          <SubscriptionList 
            selectedId={this.state.subscriptionId} 
            onSelectionChange={this.handleSetSelection}
            onIdClick={this.handleSubscriptionIdClick}
            shopFilter={this.state.shopFilter}
            statusFilter={this.state.statusFilter}
            />
        )
      default: 
        return <p>No view found</p>
    }
  }

  renderPanels(page) {
    switch(page) {
      case "subscriptions":
        if (this.state.selectedPanelId === "properties") {
          return this.buildPanels(List([SubscriptionInfoPanel]));
        } else if (this.state.selectedPanelId === "log") {
          return this.buildPanels(List([LogPanel]));
        } else if (this.state.selectedPanelId === "general") {
          return this.buildPanels(List(["shopFilter", "statusFilter"]));
        } else if (this.state.selectedPanelId === "notes") {
          return this.buildPanels(List([NotesPanel]));
        }
        break;
      default:
        return null;
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case "shopFilter":
        return <FilterPanel
          key="ShopFilterPanel"
          title="Shop Filter"
          expanded={true}
          options={getAllShopsWithAllOption()}
          onClick={this.handleSetShopFilter.bind(this)}
          filter={this.state.shopFilter}
          />      

      case "statusFilter":
        return <FilterPanel
          key="StatusFilterPanel"
          title="Status Filter"
          expanded={true}
          options={statusFilterOptions}
          onClick={this.handleSetStatusFilter.bind(this)}
          filter={this.state.statusFilter}
          />        

      case SubscriptionInfoPanel:
        if (!this.state.hasSubscriptionSelection) return null;
        return <SubscriptionInfoPanel key="SubscriptionInfoPanel" subscriptionId={this.state.subscriptionId} />

      case LogPanel:
        if (!this.state.hasSubscriptionSelection) return null;
        return <LogPanel 
                  key="LogPanel" 
                  subscriptionId={this.state.subscriptionId} 
                  limitHeight={false} />

      case NotesPanel:
        return <NotesPanel key="NotesPanel" foreignType={SUBSCRIPTION_TYPE} foreignId={this.state.subscriptionId} />
            
      default:
        return null;      
    }
  } 

  handleSetShopFilter(item) {
    this.setState({
      shopFilter: item.get("id")
    });
  }     

  handleSetStatusFilter(item) {
    this.setState({
      statusFilter: item.get("id")
    });
  }     

  handlePanelItemSelection(id) {
    this.setState({selectedPanelId: id});
  }  

  handleSetSelection(id) {
    this.setState({subscriptionId: id, hasSubscriptionSelection: true, selectedPanelId: "properties"});
  }

  handleSubscriptionIdClick(id, accountId) {
    this.props.router.push(`/subscriptions/${id}`);    
  }

  handleAnnotateSubscription(e) {
    this.props.requestCreateNote(SUBSCRIPTION_TYPE, this.state.subscriptionId);  
  }

}

export default connect(null, {requestCreateNote})(withApollo(SubscriptionsPage));